/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetSubAccountOverviewResponse,
  GetSubAccountProductSummaryResponse,
  UtxExchangeSubAccountGetProductsParams,
  GetSubAccountResponse,
  OpenSubAccountRequest,
  GetBrokersResponse,
  CreateExchangeSubAccountTransferResponse,
  CreateExchangeSubAccountTransferRequest,
  GetExchangeSubAccountTransferResponse,
  UtxExchangeSubAccountGetSecuritiesTransferParams
} from './schema'



/**
 * Returns exchange account overview
 */
export const utxExchangeSubAccountGetOverview = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetSubAccountOverviewResponse>> => {
    return axios.get(
      `/exchange-sub-accounts/overview`,options
    );
  }


export const getUtxExchangeSubAccountGetOverviewQueryKey = () => [`/exchange-sub-accounts/overview`];

    
export type UtxExchangeSubAccountGetOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof utxExchangeSubAccountGetOverview>>>
export type UtxExchangeSubAccountGetOverviewQueryError = AxiosError<unknown>

export const useUtxExchangeSubAccountGetOverview = <TData = Awaited<ReturnType<typeof utxExchangeSubAccountGetOverview>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxExchangeSubAccountGetOverview>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxExchangeSubAccountGetOverviewQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxExchangeSubAccountGetOverview>>> = ({ signal }) => utxExchangeSubAccountGetOverview({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxExchangeSubAccountGetOverview>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Returns exchange account product summary
 */
export const utxExchangeSubAccountGetProducts = (
    params?: UtxExchangeSubAccountGetProductsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetSubAccountProductSummaryResponse>> => {
    return axios.get(
      `/exchange-sub-accounts/summary/product`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxExchangeSubAccountGetProductsQueryKey = (params?: UtxExchangeSubAccountGetProductsParams,) => [`/exchange-sub-accounts/summary/product`, ...(params ? [params]: [])];

    
export type UtxExchangeSubAccountGetProductsQueryResult = NonNullable<Awaited<ReturnType<typeof utxExchangeSubAccountGetProducts>>>
export type UtxExchangeSubAccountGetProductsQueryError = AxiosError<unknown>

export const useUtxExchangeSubAccountGetProducts = <TData = Awaited<ReturnType<typeof utxExchangeSubAccountGetProducts>>, TError = AxiosError<unknown>>(
 params?: UtxExchangeSubAccountGetProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxExchangeSubAccountGetProducts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxExchangeSubAccountGetProductsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxExchangeSubAccountGetProducts>>> = ({ signal }) => utxExchangeSubAccountGetProducts(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxExchangeSubAccountGetProducts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Returns list of brokerage accounts
 */
export const utxExchangeSubAccountGetAccounts = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetSubAccountResponse>> => {
    return axios.get(
      `/exchange-sub-accounts/accounts`,options
    );
  }


export const getUtxExchangeSubAccountGetAccountsQueryKey = () => [`/exchange-sub-accounts/accounts`];

    
export type UtxExchangeSubAccountGetAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof utxExchangeSubAccountGetAccounts>>>
export type UtxExchangeSubAccountGetAccountsQueryError = AxiosError<unknown>

export const useUtxExchangeSubAccountGetAccounts = <TData = Awaited<ReturnType<typeof utxExchangeSubAccountGetAccounts>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxExchangeSubAccountGetAccounts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxExchangeSubAccountGetAccountsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxExchangeSubAccountGetAccounts>>> = ({ signal }) => utxExchangeSubAccountGetAccounts({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxExchangeSubAccountGetAccounts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Request to open sub account
 */
export const utxExchangeSubAccountOpenSubAccount = (
    openSubAccountRequest: OpenSubAccountRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/exchange-sub-accounts/open-account`,
      openSubAccountRequest,options
    );
  }



    export type UtxExchangeSubAccountOpenSubAccountMutationResult = NonNullable<Awaited<ReturnType<typeof utxExchangeSubAccountOpenSubAccount>>>
    export type UtxExchangeSubAccountOpenSubAccountMutationBody = OpenSubAccountRequest
    export type UtxExchangeSubAccountOpenSubAccountMutationError = AxiosError<unknown>

    export const useUtxExchangeSubAccountOpenSubAccount = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxExchangeSubAccountOpenSubAccount>>, TError,{data: OpenSubAccountRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxExchangeSubAccountOpenSubAccount>>, {data: OpenSubAccountRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxExchangeSubAccountOpenSubAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxExchangeSubAccountOpenSubAccount>>, TError, {data: OpenSubAccountRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Returns list of brokers
 */
export const utxExchangeSubAccountGetBrokers = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetBrokersResponse[]>> => {
    return axios.get(
      `/exchange-sub-accounts/brokers`,options
    );
  }


export const getUtxExchangeSubAccountGetBrokersQueryKey = () => [`/exchange-sub-accounts/brokers`];

    
export type UtxExchangeSubAccountGetBrokersQueryResult = NonNullable<Awaited<ReturnType<typeof utxExchangeSubAccountGetBrokers>>>
export type UtxExchangeSubAccountGetBrokersQueryError = AxiosError<unknown>

export const useUtxExchangeSubAccountGetBrokers = <TData = Awaited<ReturnType<typeof utxExchangeSubAccountGetBrokers>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxExchangeSubAccountGetBrokers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxExchangeSubAccountGetBrokersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxExchangeSubAccountGetBrokers>>> = ({ signal }) => utxExchangeSubAccountGetBrokers({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxExchangeSubAccountGetBrokers>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Create Exchange Sub Account transfer request
 */
export const createExchangeSubaccountTransferRequest = (
    createExchangeSubAccountTransferRequest: CreateExchangeSubAccountTransferRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateExchangeSubAccountTransferResponse>> => {
    return axios.post(
      `/exchange-sub-accounts/transfer`,
      createExchangeSubAccountTransferRequest,options
    );
  }



    export type CreateExchangeSubaccountTransferRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createExchangeSubaccountTransferRequest>>>
    export type CreateExchangeSubaccountTransferRequestMutationBody = CreateExchangeSubAccountTransferRequest
    export type CreateExchangeSubaccountTransferRequestMutationError = AxiosError<unknown>

    export const useCreateExchangeSubaccountTransferRequest = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExchangeSubaccountTransferRequest>>, TError,{data: CreateExchangeSubAccountTransferRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExchangeSubaccountTransferRequest>>, {data: CreateExchangeSubAccountTransferRequest}> = (props) => {
          const {data} = props ?? {};

          return  createExchangeSubaccountTransferRequest(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof createExchangeSubaccountTransferRequest>>, TError, {data: CreateExchangeSubAccountTransferRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Get Exchange Sub Account transfer
 */
export const utxExchangeSubAccountGetSecuritiesTransfer = (
    params?: UtxExchangeSubAccountGetSecuritiesTransferParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetExchangeSubAccountTransferResponse>> => {
    return axios.get(
      `/exchange-sub-accounts/transfer`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxExchangeSubAccountGetSecuritiesTransferQueryKey = (params?: UtxExchangeSubAccountGetSecuritiesTransferParams,) => [`/exchange-sub-accounts/transfer`, ...(params ? [params]: [])];

    
export type UtxExchangeSubAccountGetSecuritiesTransferQueryResult = NonNullable<Awaited<ReturnType<typeof utxExchangeSubAccountGetSecuritiesTransfer>>>
export type UtxExchangeSubAccountGetSecuritiesTransferQueryError = AxiosError<unknown>

export const useUtxExchangeSubAccountGetSecuritiesTransfer = <TData = Awaited<ReturnType<typeof utxExchangeSubAccountGetSecuritiesTransfer>>, TError = AxiosError<unknown>>(
 params?: UtxExchangeSubAccountGetSecuritiesTransferParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxExchangeSubAccountGetSecuritiesTransfer>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxExchangeSubAccountGetSecuritiesTransferQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxExchangeSubAccountGetSecuritiesTransfer>>> = ({ signal }) => utxExchangeSubAccountGetSecuritiesTransfer(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxExchangeSubAccountGetSecuritiesTransfer>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

